import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MetaMenuLinkItemViewModel } from '@models/api.models';
import { RouterLink } from '@angular/router';
import { IsClubMemberPagePipe } from '@features/club/pipes/is-club-member-page.pipe';
import { AsyncPipe, NgClass } from '@angular/common';
import { TranslateSafePipe } from '@shared/translate-safe/translate-safe.pipe';
import { ClubMemberLinkComponent } from '@features/navigation/shared/club-member-link/club-member-link.component';

@Component({
    selector: 'app-meta-menu',
    templateUrl: './meta-menu.component.html',
    styleUrls: ['./meta-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [RouterLink, IsClubMemberPagePipe, AsyncPipe, NgClass, TranslateSafePipe, ClubMemberLinkComponent]
})
export class MetaMenuComponent {
    @Input()
    public readonly metaMenuLinks?: MetaMenuLinkItemViewModel[] | null;
}
